import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RedirectService {

  constructor() { }

  redirectToURL(url : string) {
    if(url.includes('http')){
      window.open(url, '_blank');
    } else {
      window.open(url, '_self');
    }
  }

  validateTargetURL(url: string): string {
    if(url.includes('http')){
      return '_blank';
    } else {
      return '_self';
    }
  }
}
